import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/app/(core)/(other)/about/AboutContent.tsx");
